<template>
  <div class="card shadow mt-2 mb-3 border-0" style="position:relative;">
    <div class="card-body">
      <div class="title">
        <div class="wrap">
          <h5>Маркировка ссылок
          <popper hover content="Есть возможность отдельно помечать отзывы, на которые у вас ссылка. Задайте название пометки и загрузите список ссылок - все загруженные отзывы по загруженным ссылкам будут помечены тем названием, которое вы впишите.
Пример: пометить отзывы, которые были оставлены собственными силами, не органически">
    <i class="bi bi-info pointer"></i>
  </popper>
          </h5>
          <div class="sub-title">Настройте название для маркировки загруженных ссылок</div>
        </div>
      </div>
      <form @submit.prevent="saveSettings" class="row align-items-center">
        <div class="col">
          <div class="form-floating">
            <input id="name" class="form-control" required v-model="settings.name_for_our" placeholder="Название">
            <label for="name">Название для маркировки</label>
          </div>
        </div>
        <div class="col-lg-2">
          <button class="btn btn-primary" type="submit"> Сохранить</button>
        </div>
      </form>

      <form @submit.prevent="uploadMarkedLink" class="border border-secondary border-opacity-25 rounded p-3 mt-3">
        <h5>Загрузка ссылок на отзывы для маркировки</h5>
        <div class="form-item">
          <label for="">Введите ссылки<sup>*</sup> <sub>(каждая ссылка с новой строки)</sub></label>
          <textarea v-model="text_link" required id="" cols="30" rows="30" style="height: 150px"
                    class="form-control"></textarea>
          <button class="btn btn-primary mt-2" type="submit"> Загрузить</button>
        </div>


      </form>

    </div>

    <modal modal_id="upload_result">
      <template v-slot:header>
        <h4>Загружено</h4>
      </template>
      <template v-slot:body>
        <template v-if="report_upload">
          <b>Отчёт загрузки:</b><br>
          <span><b>Всего: </b>{{ report_upload.total_links }}</span><br>
          <span><b>Загружено: </b>{{ report_upload.updated_count }}</span><br>
          <span><b>Не загружено: </b>{{ report_upload.not_uploaded_count }}</span><br>
          <div v-if="report_upload.not_uploaded_links.length" class="domain-support">
            <strong>Отсутствующие отзывы:</strong>
            <ul>
              <li v-for="link in report_upload.not_uploaded_links">{{ link }}</li>
            </ul>
            <button class="btn btn-secondary" title="Копировать" @click.prevent="copyModalData"><i
                class="bi bi-copy"></i></button>
          </div>
        </template>
      </template>


      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'upload_result')"
                data-bs-dismiss="modal">Закрыть
        </button>
      </template>
    </modal>

  </div>

</template>

<script>

import {ProjectApi} from "@/api/projects";


export default {
  name: 'MarkerSettings',
  components: {},
  props: {},
  data() {
    return {
      settings: {name_for_our: ""},
      text_link: "",
      report_upload: null
    }

  },

  mounted: function () {
    const $this = this;
    ProjectApi.get_review_settings(this.project_id).then(response => {
      $this.settings.name_for_our = response.name_for_our
    })
  },
  computed: {
    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },

  methods: {

    saveSettings() {
      const $this = this;
      ProjectApi.get_review_settings(this.project_id).then(response => {
        const settings = {
          ...response,
          ...$this.settings
        }
        ProjectApi.save_review_settings(this.project_id, settings).then(() => {
          $this.$notify({
            type: "success",
            text: 'Настройки сохранены'
          })
        })

      })

    },

    uploadMarkedLink() {
      const $this = this;
      ProjectApi.upload_marked_link(this.project_id, {links: this.text_link}).then(response => {
        $this.report_upload = response;
        $this.text_link = ""
        $this.$modal('show', 'upload_result')
      })

    },
    copyModalData() {
      let textToCopy = this.report_upload.not_uploaded_links.join('\n');

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              this.$notify({
                type: "success",
                text: 'Список скопирован в буфер обмена'
              })
            })
            .catch(err => {
              console.error('Ошибка копирования:', err);
              this.fallbackCopyText(textToCopy);
            });
      } else {
        // Для старых браузеров
        this.fallbackCopyText(textToCopy);
      }
    },
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.log('Текст скопирован (fallback метод)');
        } else {
          console.error('Не удалось скопировать текст');
        }
      } catch (err) {
        console.error('Ошибка копирования (fallback):', err);
      }
      document.body.removeChild(textarea);
    },
  }
}

</script>
<style scoped lang="scss">

.domain-support {
  position: relative;

  ul {
    height: 150px;
    overflow: auto;
    padding-left: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    list-style-type: none;
  }

  .btn {
    position: absolute;
    right: 25px;
    top: 30px;
  }
}
</style>

